import CJRPng from '../../assets/logo_cjr.png';
import { useMemo } from 'react';

export enum LogoPositions {
  'HOME' = 'HOME',
  'SIDEBAR' = 'SIDEBAR',
  'MOBILENAVBAR' = 'MOBILENAVBAR',
}

interface CJRLogoProps {
  logoPosition: LogoPositions;
}

export const CJRLogo = ({ logoPosition }: CJRLogoProps) => {
  const styleByPosition = useMemo(() => {
    if (logoPosition === LogoPositions.HOME) {
      return {
        divConsts: 'relative bottom-1 right-2 cursor-pointer',
        imgConsts: 'absolute bottom-1 right-2',
        imgSize: 70,
      };
    }
    if (logoPosition === LogoPositions.SIDEBAR) {
      return {
        divConsts: 'flex flex-row justify-center p-0 m-0',
        imgConsts: '',
        imgSize: 45,
      };
    }

    if (logoPosition === LogoPositions.MOBILENAVBAR) {
      return {
        divConsts: 'flex cursor-pointer self-end justify-center',
        imgConsts: '',
        imgSize: 45,
      };
    }
  }, [logoPosition]);

  return (
    <>
      <a href="https://www.cjr.org.br/" target="_blank" rel="noreferrer">
        <div
          className={styleByPosition?.divConsts}
          title="Desenvolvido por CJR"
        >
          <img
            alt="Desenvolvido por CJR"
            src={CJRPng}
            height={styleByPosition?.imgSize}
            className={styleByPosition?.imgConsts}
          />
        </div>
      </a>
    </>
  );
};
